import { useEffect, useState } from 'react';

const defaultScrollPosition = {
  y: NaN,
  x: NaN,
  percentageY: NaN,
  percentageX: NaN,
};

function getScroll(domElement) {
  if (!domElement) {
    return defaultScrollPosition;
  }

  const isWindow = domElement.scrollY !== undefined;

  const y = isWindow ? domElement.scrollY : domElement.scrollTop;
  const x = isWindow ? domElement.scrollX : domElement.scrollLeft;

  const totalHeight = isWindow
    ? document.body.scrollHeight - window.innerHeight
    : domElement.scrollHeight - domElement.offsetHeight;

  const totalWidth = isWindow
    ? document.body.scrollWidth - window.innerWidth
    : domElement.scrollWidth - domElement.offsetWidth;

  const roundPercentageY = Math.round((100 / totalHeight) * y);
  const roundPercentageX = Math.round((100 / totalWidth) * x);

  return {
    y,
    x,
    percentageY: roundPercentageY,
    percentageX: roundPercentageX,
  };
}

function useScrollPosition(elementRef) {
  const [scrollPosition, setScrollPosition] = useState(defaultScrollPosition);

  useEffect(() => {
    const domElement =
      elementRef === 'window' && process.browser ? window : elementRef.current;

    if (!domElement) {
      return false;
    }

    function handleScroll() {
      setScrollPosition(getScroll(domElement));
    }

    domElement.addEventListener('scroll', handleScroll);
    return () => domElement.removeEventListener('scroll', handleScroll);
  });

  return scrollPosition;
}

export default useScrollPosition;
